module.exports = __webpack_public_path__ + "img/Lamborghini.09b0848a.png";